// Bootstraps the AppointmentBooking.ProviderWidget namespace so that view/
// template/model files can reference it at module-evaluation time. Must be
// imported FIRST by index.js and by every view file under views/ that touches
// AppointmentBooking.ProviderWidget.Events.* at module top level (e.g. in a
// `static { ... }` block).
//
// Intentionally uses per-key `??=` assignments on the inner structure rather
// than a single `ProviderWidget ??= {...}` at the top. Under Vite, the
// `import.meta.glob({ eager: true })` expansion in index.js evaluates the
// view files in alphabetical order (address_selector.js, patient_type_selector.js,
// slot_list.js, widget.js). The first three each contain a top-level
// `window.AppointmentBooking.ProviderWidget ??= {};` guard which will set
// ProviderWidget to an empty `{}` before this file gets a chance to run — so
// by the time _namespaces.js evaluates (as a dep of widget.js), a bail-out
// `ProviderWidget ??= {...}` would be a no-op and Events would never be
// populated. Instead, we merge into whatever object is already there.
window.AppointmentBooking ??= {};
window.AppointmentBooking.ProviderWidget ??= {};

const pw = window.AppointmentBooking.ProviderWidget;
pw.Views ??= {};
pw.Models ??= {};
pw.Collections ??= {};
pw.Events ??= {
  AddressSelector: {
    addressSelected: "appointmentBookingWizardProviderWidget-addressSelected",
  },
  PatientTypeSelector: {
    patientTypeSelected: "appointmentBookingWizardProviderWidget-patientTypeSelected",
  },
  slotPick: "appointmentBookingWizardProviderWidget-slotPick",
};
